import { trackEvent } from 'helpers/analytics'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TranslationContextProvider } from '../../../components/discover/aivy-pdf-reports/context/general-translations'
import AssistantDrawer from '../components/AssistantDrawer'
import ProgressBar from '../components/create-career/ProgressBar'
import Step1ChooseExample from '../components/create-career/Step1ChooseExample'
import Step2Configure from '../components/create-career/Step2Configure'
import DiscoverPageLayout from '../components/DiscoverPageLayout'
import { DiscoverContextProvider } from '../context/DiscoverContext'

export default function CreateCareerFlow() {
  const [step, setStep] = useState(1)
  const [selectedExample, setSelectedExample] = useState(null)
  const navigate = useNavigate()

  // Step-Funnel des Discover-Create-Flows (eigener 2-Schritte-Flow neben dem
  // klassischen 5-Step-Flow) — war komplett ungetrackt. Rock Q3/26.
  useEffect(() => {
    trackEvent(`discover_create_career_step_${step}_viewed`)
  }, [step])

  // „Zurück" aus Step 1: navigate(-1) führt ins Leere, wenn diese Seite der
  // erste History-Eintrag ist — genau der Fall bei Variante B des Experiments
  // onboarding_skip (Landung direkt hier) und bei jedem Deeplink. React Router
  // zählt seine Einträge in history.state.idx.
  const handleExit = () => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1)
    else navigate('/discover', { replace: true })
  }

  return (
    <DiscoverContextProvider>
      <div className='flex flex-row'>
        <div className='flex w-full flex-1'>
          <DiscoverPageLayout>
            <TranslationContextProvider data={null}>
              <ProgressBar currentStep={step} totalSteps={2} />

              {step === 1 && (
                <Step1ChooseExample
                  example={selectedExample}
                  onBack={handleExit}
                  onNext={(example) => {
                    setSelectedExample(example)
                    setStep(2)
                  }}
                />
              )}
              {step === 2 && (
                <Step2Configure
                  example={selectedExample}
                  onBack={() => setStep(1)}
                  onFinish={() => {}}
                />
              )}
            </TranslationContextProvider>
          </DiscoverPageLayout>
        </div>
        {
          <TranslationContextProvider data={null}>
            <AssistantDrawer />
          </TranslationContextProvider>
        }
      </div>
    </DiscoverContextProvider>
  )
}
